module.exports = __webpack_public_path__ + "img/jolidon.a1e7388d.jpg";